// extracted by mini-css-extract-plugin
module.exports = {"txCreation":"styles_txCreation__n_ScU","txSummary":"styles_txSummary__62A4Y"};